<template>
    <div class="searchContent">
        <a-affix>
            <a-card :title="this.$slots.default">
                <a-form layout="inline" @submit="handleSubmit" :form="form">
                    <a-form-item label="关键字">
                        <a-input
                            v-decorator="[
                                'keyword',
                                {
                                    initialValue: record.keyword || '',
                                }
                            ]"
                            placeholder="请输入关键字"
                        ></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-button
                            type="primary"
                            htmlType="submit"
                            :key="this.loading.key"
                            :loading="this.loading.effects[selectType] || this.loading.effects[`${storeNamespace}/jibie`]"
                        >查询</a-button>
                        <v-resetbutton
                            :key="Math.random()"
                            :loading="this.loading.effects[selectType] || this.loading.effects[`${storeNamespace}/jibie`]"
                            :redirect="{path:`/${storeNamespace}/${action}`}"
                            class="ml15"
                        >重置</v-resetbutton>
                    </a-form-item>
                </a-form>
            </a-card>
        </a-affix>
    </div>
</template>

<script>

const storeNamespace = "servicekey";

export default {
    data() {
        return {
            storeNamespace,
            selectType: `${storeNamespace}/select`,
            deleteType: `${storeNamespace}/delete`,
            form: this.$form.createForm(this),
            record: this.$route.query || {},
            action: ""
        };
    },
    computed: {},
    methods: {
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (err) return;

                /**
                 * 是的你没看错，这边触发重新去查询数据，只要让路由改变query的参数值即可，无需this.$store.dispatch({})去调用actions里面的方法，
                 * dispatch由同辈级(兄弟组件)  tablelist.vue 中去处理。
                 */
                this.$router.push({
                    path: this.action,
                    query: values
                });
            });
        }
    },
    beforeMount() {},
    mounted() {
        const { path } = this.$route;
        this.action = path.split("/").pop();
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item {
    margin-bottom: 20px;
}
</style>